import { baseQueryWithReauth } from './baseQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const notificationsApi = createApi({
    reducerPath: 'notifications',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['notifications'],
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: ({ filters }) => ({
                url: 'comunicaciones',
                params: { ...filters, take: filters?.take < 10 ? 10 : filters?.take }
            })
        }),
        setRead: builder.mutation({
            query: (id) => ({
                url: `comunicaciones/${id}/leida`,
                method: 'PUT'
            })
        }),
        getTiposNotificaciones: builder.query({
            query: () => ({
                url: 'comunicaciones/tipos-mensajes'
            })
        })
    })
});

export const {
    useGetNotificationsQuery,
    useSetReadMutation,
    useLazyGetNotificationsQuery,
    useGetTiposNotificacionesQuery,
    useLazyGetTiposNotificacionesQuery
} = notificationsApi;
